import React, { useState, useEffect, useField, Field } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { baseURL } from "../../config";

function UserFormToFill() {
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [emailWarning, setEmailWarning] = useState(false);
  const [staffNumberWarning, setStaffNumberWarning] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const [formData, setFormData] = useState(null);
  const [departmentsData, setDepartmentsData] = useState(null);
  const [options, setOptions] = useState([]);
  const [grades, setGrades] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [supervior, setSupervior] = useState([]);
  const [designationData, setDesignationData] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [designation, setDesignation] = useState("");
  const [selectedDepartmentid, setSelctedDepartmentid] = useState(null);
  const [isMember, setIsMember] = useState(false);
  const [memberVal, setMemberVal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [file, setFile] = useState(null);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [mobileNumber, setMobileNumber] = useState(null);
  const [password, setPassword] = useState(null);
  const [grade, setGrade] = useState(null);
  const [email, setEmail] = useState(null);
  const [employeeName, setEmployeeName] = useState(null);
  const [lastname, setEmployeLastName] = useState(null);

  const [manager, setManager] = useState(null);
  const [supervisorid, setSupervisorid] = useState("");
  const [profileimage, setProfileImage] = useState(null);
  const [idImage, setIdImage] = useState(null);
  const [staffnumber, setStaffNumber] = useState(null);
  const [roleid, setRoleid] = useState(null);
  const [idimagechanged, setIdImageChanged] = useState(false);
  const [profileimagechanged, setProfileImageChanged] = useState(false);
  const [activeStatus, setActiveStatus] = useState("1");
  const navigate = useNavigate();

  const handleRadioChange = (val) => {
    if (val === "Yes") {
      setIsMember(true);
      setMemberVal("Yes");
    } else {
      setIsMember(false);
      setMemberVal("No");
    }
  };

  const handlegradeChange = (e) => {
    let changedgrade = e.target.value;
    setGrade(changedgrade);
  };
  const handleStaffNumber = (e) => {
    let changedstaff = e.target.value;
    setStaffNumberWarning(false);
    const isStaffnumberExists = staffNumberCheck(changedstaff);

    if (isStaffnumberExists === true) {
      setStaffNumberWarning(true);
    } else {
      setStaffNumberWarning(false);
      setStaffNumber(changedstaff);
    }
  };

  const handleNameChange = (e) => {
    let changedname = e.target.value;
    setEmployeeName(changedname);
  };
  const handleLastNameChange = (e) => {
    let changedname = e.target.value;
    setEmployeLastName(changedname);
  };
  const handleDesignationChange = (e) => {
    let designationchange = e.target.value;
    setDesignation(designationchange);
  };
  const handleManagerChange = (e) => {
    let managerchange = e.target.value;
    setManager(managerchange);
  };

  const handleSupervisorChange = (e) => {
    let supervisorchange = e.target.value;
    if (supervisorchange === 0) {
      setSupervisorid(0);
    } else {
      setSupervisorid(supervisorchange);
    }
  };

  const roleChange = (rolechange) => {
    setRoleid(rolechange);
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const uid = searchParams.get("uid");

  const isAppealcommiteeMember = localStorage.getItem(
    "appealcommiteememberstatus"
  );

  const departmentChange = async (dempartmentid) => {
    setSelctedDepartmentid(dempartmentid);
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${baseURL}/allgrades`);
        setGrades(response.data.grades);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        if (uid != null) {
          const response = await axios.get(
            `${baseURL}/getemployeedetails?uid=` + uid
          );
          setEmployeeDetails(response.data.employee[0]);
          let emp = response.data.employee[0];
          setSelctedDepartmentid(emp.departmentid);

          if (emp.isappealcommitteemember === "Yes") {
            setIsMember(true);
            setMemberVal("Yes");
          } else {
            setIsMember(false);
            setMemberVal("No");
          }
          setStaffNumber(emp.employeeid);

          setGrade(emp.gradeid);
          setMobileNumber(emp.phone);
          setEmail(emp.email);
          setDesignation(emp.designationid);
          setManager(emp.managerid);
          setSupervisorid(emp.supervisorid);
          setEmployeeName(emp.FirstName);
          setEmployeLastName(emp.LastName);
          setRoleid(emp.roleid);
          setProfileImage(emp.profileimage);
          setIdImage(emp.idattchment);
          setActiveStatus(emp.status);
        }
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchEmployee();
  }, []);

  const fetchDesignations = async () => {
    try {
      const resp = await axios.get(`${baseURL}/getdeignations`);

      if (resp.statusText === "OK") {
        setDesignationData(resp.data.designations);
      } else {
        console.error("Designation fetch failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const emailCheck = async (email) => {
    try {
      const resp = await axios.get(`${baseURL}/checkemail?email=` + email);
      const arr = resp.data.user;

      if (arr[0]?.email === email) {
        setEmailWarning(true);
        return true;
      } else {
        setEmailWarning(false);
        return false;
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const staffNumberCheck = async (staffnumber) => {
    try {
      const resp = await axios.get(
        `${baseURL}/checkstaffno?eid=` + staffnumber
      );
      const arr = resp.data.user;

      if (arr[0]?.employeeid === staffnumber) {
        setStaffNumberWarning(true);
        return true;
      } else {
        setStaffNumberWarning(false);
        setStaffNumber(staffnumber);
        return false;
      }
      return false;
    } catch (error) {
      console.error("An error occurred:", error);
      return false;
    }
  };

  const [value, setValue] = useState([]);
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await axios.get(`${baseURL}/getdepartments`);
        setOptions(response.data.departments);
      } catch (error) {
        console.error("Error fetching options:", error);
      }
    };
    fetchOptions();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${baseURL}/manager`);
        setEmployees(response.data.employees);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };
    fetchEmployees();
    fetchDesignations();
  }, []);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await axios.get(`${baseURL}/supervior`);
        setSupervior(response.data.supervior);
      } catch (error) {
        console.error("Error fetching supervior:", error);
      }
    };
    fetchEmployees();
    //  fetchDesignations();
  }, []);

  const handleSubmit = async (values) => {
    if (
      grade &&
      email &&
      roleid &&
      employeeName &&
      designation &&
      staffnumber &&
      selectedDepartmentid
    ) {
      setFormData(values); // Store form data before displaying the modal
      setShowModal(true); // Show the confirmation modal
    } else {
      setShowErrorModal(true);
      return;
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setShowErrorModal(false);
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      let fileval = e.target.files[0];
      setFile(fileval);
      setIdImageChanged(true);
    }
  };

  const handleProfileImageChange = (e) => {
    if (e.target.files) {
      let fileval = e.target.files[0];
      setProfileImage(fileval);
      setProfileImageChanged(true);
    }
  };
  const handleConfirmUpdate = async (formData) => {
    const stringifiedformvalues = JSON.stringify(formData);
    let response = null;
    if (profileimagechanged || idimagechanged) {
      const updatedFormData = { ...formData };

      // Append the file to the existing formData
      if (file !== null) {
        updatedFormData.attachid = file;
      }
      if (profileimage !== null) {
        updatedFormData.image = profileimage;
      }

      // Send the formData with the file to the server

      const formDataToSend = new FormData();
      for (const key in updatedFormData) {
        formDataToSend.append(key, updatedFormData[key]);
      }
      response = await fetch(
        `${baseURL}/updateuserwithattachments?uid=` + uid,
        {
          method: "POST",
          body: formDataToSend,
        }
      );
    } else {
      response = await axios.post(
        `${baseURL}/updateusernoattachments?uid=` + uid,
        stringifiedformvalues,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    }

    if (response.status === 200) {
      // Reset form data and close modal after successful submission
      setFormData(null);
      setShowModal(false);
      setShowToast(true);
      // Redirect to the desired page

      setTimeout(() => {
        setShowToast(false);
        navigate("/userTable");
      }, 3000);
    } else {
      // Handle the case where the form submission fails
      console.error("Form submission failed");
    }
  };
  const mobileChange = (phoneval) => {
    {
      setMobileNumber(phoneval);
    }
  };
  const passwordChange = (password) => {
    {
      setPassword(password);
    }
  };
  const emailChange = (emailval) => {
    {
      const isEmailPresent = emailCheck(emailval);
      if (isEmailPresent === true) {
        return;
      }

      setEmail(emailval);
    }
  };
  const handleConfirmSubmit = async () => {
    try {
      // Perform form submission with the stored form data
      console.log("Submitting form:", formData);
      if (uid !== null) {
        handleConfirmUpdate(formData);

        // window.location.href='/userTable';
        return;
      }
      // If a file is selected, attach it to the form data

      const updatedFormData = { ...formData };

      // Append the file to the existing formData
      if (file !== null) {
        updatedFormData.attachid = file;
      }
      if (profileimage !== null) {
        updatedFormData.image = profileimage;
      }

      let response = null;
      // Send the formData with the file to the server
      if (file !== null || profileimage !== null) {
        const formDataToSend = new FormData();
        for (const key in updatedFormData) {
          formDataToSend.append(key, updatedFormData[key]);
        }
        response = await fetch(`${baseURL}/adduser`, {
          method: "POST",
          body: formDataToSend,
        });
      } else {
        const stringifiedformvalues = JSON.stringify(formData);
        response = await axios.post(
          `${baseURL}/addusernoattachments`,
          stringifiedformvalues,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }
      // Send the formData with the file to the server

      if (response.status === 200) {
        // Reset form data and close modal after successful submission
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        // Redirect to the desired page

        setTimeout(() => {
          setShowToast(false);
          navigate("/userTable");
        }, 3000);
      } else {
        // Handle the case where the form submission fails
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          name: "",
          lastname: "",
          staffnumber: "",
          email: "",
          attachid: "",
          phoneNumber: "",
          profileimg: "",
          role: "",
          departmentid: "",
          designationid: "",
          manager: "",
          gradeid: grade,
          status: activeStatus,
          supervisor: "",
          isMember: memberVal,
          password: "",
        }}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">New User Creation Form </h4>
            <h5>{uid ? <labbel>Edit User</labbel> : null}</h5>
            <div className="col-lg-12  mt-1 m-5">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5 ">
                    <table style={{ "background-color": "white" }}>
                      <tr>
                        <td style={{ "background-color": "white" }}>
                          <label className="formlabel ">
                            <span className="text-danger">*</span>First Name{" "}
                          </label>

                          <input
                            required
                            type="text"
                            className={`form-control rounded-pill ${
                              touched.name && errors.name ? "is-invalid" : ""
                            }`}
                            placeholder="Enter First Name"
                            name="name"
                            value={(values.name = employeeName)}
                            onChange={(e) => {
                              handleNameChange(e);
                            }}
                          />
                          {touched.name && errors.name ? (
                            <div className="text-danger">{errors.name}</div>
                          ) : null}
                        </td>
                        <td style={{ "background-color": "white" }}>
                          <label className="formlabel">
                            <span className="text-danger"></span>Last Name
                          </label>
                          <input
                            type="text"
                            className={`form-control rounded-pill ${
                              touched.LastName && errors.LastName
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Enter LastName"
                            name="lastname"
                            value={
                              (values.lastname =
                                lastname ||
                                (employeeDetails && employeeDetails.LastName))
                            }
                            onChange={(e) => {
                              handleLastNameChange(e);
                            }}
                          />
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div className="col-lg-5 ml-5">
                    <label className="formlabel">
                      <span className="text-danger">*</span>Staff Number{" "}
                    </label>
                    <input
                      disabled={uid}
                      required
                      type="text"
                      className={`form-control rounded-pill ${
                        touched.staffnumber && errors.staffnumber
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter Staffnumber"
                      name="staffnumber"
                      value={
                        (values.staffnumber =
                          staffnumber ||
                          (employeeDetails && employeeDetails.employeeid))
                      }
                      onChange={(e) => {
                        handleStaffNumber(e);
                      }}
                    />
                    {staffNumberWarning ? (
                      <div className="text-danger">
                        {" "}
                        This Staff Number already exists. Please enter a
                        different one
                      </div>
                    ) : null}
                    {touched.staffnumber && errors.staffnumber ? (
                      <div className="text-danger">{errors.staffnumber}</div>
                    ) : null}
                  </div>

                  <div className="col-lg-5 mt-3">
                    <label className="formlabel">
                      {" "}
                      <span className="text-danger">*</span>E-mail
                    </label>
                    <input
                      required
                      type="email"
                      className={`form-control rounded-pill ${
                        touched.email && errors.email ? "is-invalid" : ""
                      }`}
                      placeholder=""
                      name="email"
                      value={(values.email = email)}
                      onChange={(e) => {
                        emailChange(e.target.value);
                      }}
                    />
                    {emailWarning ? (
                      <div className="text-danger">
                        {" "}
                        This email already exists. Please enter a different
                        email
                      </div>
                    ) : null}
                    {touched.email && errors.email ? (
                      <div className="text-danger">{errors.email}</div>
                    ) : null}
                  </div>

                  <div class="col-lg-5 ml-5 mt-3">
                    <label for="formFile" class="form-label">
                      Attach ID
                    </label>
                    {/* <input class="form-control rounded-pill" type="file" values={values.attachid} id="formFile" /> */}
                    <input
                      class="form-control rounded-pill"
                      value={values.attachid}
                      id="file"
                      type="file"
                      onChange={handleFileChange}
                    />
                    {file && file !== null && <p>{file.name}</p>}
                    {idImage && uid ? (
                      <a
                        href={`${baseURL}/getcertifcate?filename=${idImage}`}
                        download // Add the download attribute
                      >
                        <h6> View Image</h6>
                      </a>
                    ) : null}
                  </div>

                  <div className="col-lg-5 mt-3">
                    <label className="formlabel">
                      {" "}
                      <span className="text-danger"></span>Phone
                    </label>
                    <input
                      type="number" // Use type="tel" for phone numbers
                      className={`form-control rounded-pill ${
                        touched.phoneNumber && errors.phoneNumber
                          ? "is-invalid"
                          : ""
                      }`} // Update touched and errors to phoneNumber
                      placeholder=""
                      name="phoneNumber" // Change name attribute to phoneNumber
                      value={(values.phoneNumber = mobileNumber)} // Update value to phoneNumber
                      onChange={(e) => {
                        mobileChange(e.target.value);
                      }}
                    />
                    {touched.phoneNumber && errors.phoneNumber ? (
                      <div className="text-danger">{errors.phoneNumber}</div>
                    ) : null}{" "}
                    {/* Update error message to phoneNumber */}
                  </div>

                  <div class="col-lg-5 ml-5 mt-3">
                    <label for="formFileProfile" class="form-label">
                      Attach Image
                    </label>
                    <input
                      class="form-control rounded-pill"
                      value={values.profileimg}
                      type="file"
                      onChange={handleProfileImageChange}
                    />
                    {profileimage && profileimage !== null && (
                      <p>{profileimage.name}</p>
                    )}
                    {profileimage && uid ? (
                      <a
                        href={`${baseURL}/getcertifcate?filename=${profileimage}`}
                        download // Add the download attribute
                      >
                        <h6> View Image</h6>
                      </a>
                    ) : null}
                  </div>

                  <div class="col-lg-5 mt-2 mt-3">
                    <label>
                      {" "}
                      <span className="text-danger">*</span>Roles
                    </label>

                    <select
                      className="form-select form-control"
                      name="role"
                      placeholder="Select Role"
                      value={
                        (values.role =
                          roleid || (employeeDetails && employeeDetails.roleid))
                      }
                      onChange={(e) => {
                        roleChange(e.target.value);
                      }}
                    >
                      <option valuue="0">Select Role</option>
                      <option value="1">User</option>
                      <option value="2">Manager</option>
                      <option value="3">HR</option>
                      <option value="4">Supervisor</option>
                      <option value="5">Super Admin</option>
                      <option value="6">Senior HR Manager</option>
                    </select>
                  </div>

                  <div class="col-lg-5 ml-5 mt-3">
                    <label>
                      {" "}
                      <span className="text-danger">*</span>Department
                    </label>

                    <select
                      className="form-select form-control"
                      name="departmentid"
                      value={(values.departmentid = selectedDepartmentid)}
                      onChange={(e) => {
                        departmentChange(e.target.value);
                      }}
                    >
                      <option>Select a department</option>
                      {options.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.departmentname}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div class="col-lg-5 mt-3 ">
                    <label>
                      {" "}
                      <span className="text-danger">*</span>Designation
                    </label>

                    <select
                      className="form-select form-control rounded-pill"
                      name="designationid"
                      value={
                        (values.designationid =
                          designation ||
                          (employeeDetails && employeeDetails.designationid))
                      }
                      onChange={(e) => {
                        handleDesignationChange(e);
                      }}
                    >
                      <option value="">Select Designation</option>
                      {designationData.map((designation) => (
                        <option key={designation.id} value={designation.id}>
                          {designation.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div class="col-lg-5 mt-3 ml-5">
                    <label>
                      {" "}
                      <span className="text-danger"></span>Line Manager
                    </label>
                    <select
                      className="form-select form-control rounded-pill"
                      name="manager"
                      placeholder=""
                      value={
                        (values.manager =
                          manager ||
                          (employeeDetails && employeeDetails.managerid))
                      } // Make sure this value matches the value of the selected option
                      onChange={(e) => {
                        handleManagerChange(e);
                      }}
                      // Add handleChange function to update form values
                    >
                      <option value="">Select Manager</option>
                      {employees.map((option) => (
                        <option key={option.id} value={option.employeeid}>
                          {option.FirstName} {option.LastName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div class="col-lg-5 mt-3 ">
                    <label>
                      {" "}
                      <span className="text-danger"></span>Supervisor
                    </label>
                    <select
                      className="form-select form-control rounded-pill"
                      name="supervisor"
                      placeholder=""
                      value={
                        (values.supervisor =
                          supervisorid ||
                          (employeeDetails && employeeDetails.supervisorid))
                      } // Make sure this value matches the value of the selected option
                      // Add handleChange function to update form values

                      onChange={(e) => {
                        handleSupervisorChange(e);
                      }}
                    >
                      <option value={0}>Select Supervisor</option>
                      {supervior.map((option) => (
                        <option key={option.id} value={option.employeeid}>
                          {option.FirstName} {option.LastName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div class="col-lg-5 mt-3 ml-5">
                    <label>
                      {" "}
                      <span className="text-danger">*</span>Select Grade
                    </label>

                    <select
                      className="form-select form-control rounded-pill"
                      as="select"
                      id="grade"
                      name="gradeid"
                      value={(values.gradeid = grade)}
                      onChange={(e) => {
                        handlegradeChange(e);
                      }}
                      required
                    >
                      <option value="">Select Grade</option>
                      {grades.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.gradename}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div class="col-lg-5 mt-3">
                    <label>
                      {" "}
                      <span className="text-danger"></span>Status
                    </label>

                    <select
                      className="form-select form-control rounded-pill"
                      name="status"
                      value={values.status = activeStatus}
                      onChange={(e) => {
                        const newStatus = e.target.value;
                        setActiveStatus(newStatus);
                      }}
                    >
                      <option value="1">Active</option>
                      <option value="2">Inactive</option>
                    </select>
                  </div>
                  <div class="col-lg-5 mt-5 ml-5">
                    <h6>
                      {" "}
                      <span className="text-danger">*</span>Member of Appeal
                      Committee?
                    </h6>
                    <div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                          value={(values.isMember = memberVal)}
                          checked={isMember === true}
                          onChange={(e) => {
                            handleRadioChange("Yes");
                            setIsMember(true);
                            setMemberVal("Yes");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Yes
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                          value={(values.isMember = memberVal)}
                          checked={isMember === false}
                          onChange={(e) => {
                            handleRadioChange("No");
                            setIsMember(false);
                            setMemberVal("No");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-5">
                    <label>Password</label>
                    <br></br>

                    <input
                      type="password"
                      name="password"
                      className="form-control"
                      disabled={employeeDetails && employeeDetails.password}
                      onChange={(e) => {
                        passwordChange(e.target.value);
                      }}
                      value={
                        (values.password =
                          password ||
                          (employeeDetails && employeeDetails.password))
                      }
                    ></input>
                  </div>
                </div>

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a className="text-decoration-none " href="#">
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>
      <div>
        {/* Your existing component code */}

        <ToastContainer position="bottom-end" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
      {/* Confirmation Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you Confirm this Changes</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={handleConfirmSubmit}
            disabled={isClicked}
          >
            {isClicked ? "Clicked" : "Yes"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showErrorModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <fieldset>
            <legend>
              {" "}
              <span className="text-danger">
                *Please fill all the required fields.
              </span>
            </legend>

            <ul>
              {!employeeName ? <li>Employee Name</li> : null}
              {!staffnumber ? <li>Staff Number</li> : null}
              {!email ? <li>E-Mail</li> : null}
              {!roleid ? <li>User Role</li> : null}
              {!designation ? <li>Designation</li> : null}
              {!selectedDepartmentid ? <li>Department</li> : null}
              {!grade ? <li>Grade</li> : null}
            </ul>
          </fieldset>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UserFormToFill;
